import { AxiosResponse } from 'axios';

import { SeasonsListResponse } from 'store/railsBuilder/reducer.types';

function isSeasonsListResponse(
    response: any,
): response is AxiosResponse<SeasonsListResponse> {
    return !!response?.data?.values;
}

export default isSeasonsListResponse;
